export const AR_LOCALE = "ar";
export const EN_LOCALE = "en";
export const INTL_RTL = "rtl";
export const INTL_LTR = "ltr";